import { TODAY_KEY, UPCOMING_KEY, INACTIVE_KEY, PAST_KEY } from "#deck-layout-context-value";

/** Map the current `/decks/...` pathname to the layout context `routeKey`. */
export function pathnameToDeckLayoutRouteKey(pathname: string): string {
  if (pathname.includes("/decks/inactive")) {
    return INACTIVE_KEY;
  }
  if (pathname.includes("/decks/past")) {
    return PAST_KEY;
  }
  return pathname.includes("/decks/upcoming") ? UPCOMING_KEY : TODAY_KEY;
}
